import React, { useCallback, useMemo } from 'react';

import { token } from '@atlaskit/tokens';

import { trackEvent } from 'src/lib/analytics';

const styles = {
  multiValue: (base, state) => {
    return state.data.isFixed ? { ...base, background: token('color.background.accent.gray.subtlest.pressed', '#fafafa'), paddingRight: 6 } : base;
  },
  multiValueRemove: (base, state) => {
    return state.data.isFixed ? { ...base, display: 'none' } : base;
  },
};

const actionTracking = (action, newVal) => {
  if (action === 'select-option' && Array.isArray(newVal) && newVal.length > 0) {
    const [{ key: selectedActionKey }] = newVal.slice(-1);
    if (selectedActionKey && (selectedActionKey.startsWith('pd_') || selectedActionKey.startsWith('jira_'))) {
      trackEvent('settings_manage_rule_actions', { label: selectedActionKey });
    }
  }
};

const withFixedOptionSupport = C => ({ onChange: onChangeProp, value: valueProp, fixedOptions, isClearableProp, ...rest }) => {
  const onChange = useCallback((newVal, context) => {
    const { action, removedValue } = context;
    actionTracking(action, newVal);
    switch (action) {
      case 'remove-value':
      case 'pop-value':
        if (removedValue && removedValue.isFixed) {
          return;
        }
        break;
      default:
        break;
    }
    if (Array.isArray(newVal)) {
      newVal = newVal.filter(v => v && !v.isFixed);
    }
    onChangeProp(newVal, context);
  }, [onChangeProp]);

  const value = useMemo(() => {
    if (Array.isArray(fixedOptions)) {
      return [...fixedOptions.map(o => Object.assign(o, { isFixed: true })), ...valueProp || []];
    } else {
      return valueProp;
    }
  }, [fixedOptions, valueProp]);

  const isClearable = useMemo(() => {
    if (Array.isArray(fixedOptions) && Array.isArray(value)) {
      if (value.length === fixedOptions.length) return false;
    }
    return isClearableProp;
  }, [fixedOptions, isClearableProp, value]);

  return (
    <C
      onChange={onChange}
      value={value}
      styles={styles}
      isClearable={isClearable}
      {...rest}
    />
  );
};

export default withFixedOptionSupport;
